import PageTransition from "components/PageTransition"
import ContentWrapper from "components/ContentWrapper"
import Link from "components/Link"
import { chevronBack, imageOutline, megaphoneOutline } from "ionicons/icons"
import { useLocation } from "@reach/router"
import Heading from "components/Heading"
import Subheading from "components/Subheading"
import React, { useEffect } from "react"
import styled from "styled-components"
import WIcon from "components/WIcon"
import SectionTitle from "components/SectionTitle"
import Entry from "components/Entry"
import AudioPlayer from "components/AudioPlayer"
import Gallery from "components/Gallery/Gallery"
import Row from "components/Row"
import {
  MobileMenuBarContextType,
  withMobileMenuBarContext,
} from "components/UserMenuBar/MobileMenuBar/MobileMenuBarContext"
import { ViewContextConsumer } from "context/viewContext"
import { useQuery } from "@apollo/client"
import { parseStringDate } from "tools/parseStringDate"
import {
  PAST_TRIP_QUERY,
  PAST_TRIP_QUERY_TYPE,
} from "konto/Wyjazdy/Minione/MinionyWyjazd/MinionyWyjazd.gql"
import Spinner from "components/Spinner"
import config from "config/config"
import { Helmet } from "react-helmet"

const StyledImage = styled.div.attrs<{ src: string }>(({ src }) => ({
  style: {
    backgroundImage: `url(${src})`,
  },
}))<{ src: string }>`
  padding-top: 50%;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  position: relative;
  margin-bottom: 28px;
`

const MinionyWyjazd = ({
  setMobileMenuBarValues,
}: MobileMenuBarContextType) => {
  const location = useLocation()
  const slug = location.pathname.substring(
    location.pathname.lastIndexOf("/") + 1
  )

  const { loading, error, data } = useQuery<PAST_TRIP_QUERY_TYPE>(
    PAST_TRIP_QUERY,
    {
      variables: {
        where: {
          slug: slug,
        },
      },
    }
  )

  useEffect(() => {
    if (data && data.trips && data.trips[0]) {
      const trip = data.trips[0]
      if (setMobileMenuBarValues) {
        setMobileMenuBarValues({
          type: "entry",
          title: `${trip.title}`,
          subtitle: `${trip.location}, ${parseStringDate(
            trip.from
          )} – ${parseStringDate(trip.to)}`,
          backUrl: "/konto/wyjazdy/minione",
        })
      }
    }
  }, [data, data?.trips, data?.trips[0]])

  if (data && data.trips && data.trips[0]) {
    const {
      title,
      location,
      from,
      to,
      story,
      conferences,
      gallery,
      image,
    } = data.trips[0]

    const photos = gallery.map(item => ({
      src: config.uploadPrefix + item.url,
      width: item.width,
      height: item.height,
    }))

    return (
      <>
        <Helmet>
          <title>{title} | Wspólnota 120</title>
        </Helmet>
        <ViewContextConsumer>
          {viewContext => (
            <PageTransition>
              <ContentWrapper>
                <Entry.Header>
                  {image && <StyledImage src={image.url} />}
                  {(viewContext?.media.md ||
                    viewContext?.media.lg ||
                    viewContext?.media.xl) && (
                    <Link icon={chevronBack} to={"/konto/wyjazdy/minione"}>
                      Powrót
                    </Link>
                  )}
                  <Heading>{title}</Heading>
                  <Subheading>
                    {location}, {parseStringDate(from)} – {parseStringDate(to)}
                  </Subheading>
                </Entry.Header>
                {story && !!story.length && (
                  <Entry.Section>
                    <div
                      style={{ marginBottom: "12px" }}
                      dangerouslySetInnerHTML={{ __html: story }}
                    />
                  </Entry.Section>
                )}
                {conferences && !!conferences.length && (
                  <Entry.Section>
                    <SectionTitle withLine>
                      <WIcon icon={megaphoneOutline} />
                      Konferencje
                    </SectionTitle>
                    <div style={{ marginTop: "24px" }}>
                      {conferences.map(conference => (
                        <div
                          key={conference.file.url}
                          style={{ marginBottom: "16px" }}
                        >
                          <AudioPlayer
                            title={conference.title}
                            src={conference.file.url}
                            downloadButton
                          />
                        </div>
                      ))}
                    </div>
                  </Entry.Section>
                )}
                {gallery && !!gallery.length && (
                  <Entry.Section>
                    <Row>
                      <SectionTitle withLine>
                        <WIcon icon={imageOutline} />
                        Galeria
                      </SectionTitle>
                      {/*<div style={{ marginBottom: "16px" }}>*/}
                      {/*  <Link to={"#"} icon={downloadOutline}>*/}
                      {/*    Pobierz zdjęcia*/}
                      {/*  </Link>*/}
                      {/*</div>*/}
                    </Row>
                    <div style={{ marginBottom: "12px" }}>
                      <Gallery images={photos} />
                    </div>
                  </Entry.Section>
                )}
              </ContentWrapper>
            </PageTransition>
          )}
        </ViewContextConsumer>
      </>
    )
  } else if (loading) {
    return (
      <PageTransition>
        <ContentWrapper>
          <Spinner size={32} />
        </ContentWrapper>
      </PageTransition>
    )
  } else if (error) {
    return (
      <>
        <div></div>
      </>
    )
  }
  return null
}

export default withMobileMenuBarContext(MinionyWyjazd)
